import { helpers } from 'vuelidate/lib/validators';

// All Regex Validation
export const alphaSpace = helpers.regex('alphaSpace', /^[a-zA-Z ]*$/i);
export const filename = function(value) {
  if (!value) {
    return true;
  }
  return /^[\w\d\s\\,\\_\\(\\)-]*$/i.test(value) && !['other', 'others'].includes(value.toLowerCase());
};
